/**
 * Autogenerated file don't modify
 */
(function () {
(function (swiper) {
    'use strict';

    MoyaComponents.register('site.carousel', [
        'https://cdnjs.cloudflare.com/ajax/libs/Swiper/9.4.1/swiper-bundle.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/Swiper/9.4.1/swiper-bundle.css',
    ], function (el) {
        var selector = '#' + el.id + ' .swiper-container';
        if (selector.includes('rootCategories')) {
            Carousel.handleRootCategories(selector);
        }
        else if (selector.includes('other-products-list')) {
            Carousel.handleOtherProducts(selector);
        }
        else {
            console.log(selector);
        }
    });
    var Carousel = /** @class */ (function () {
        function Carousel() {
        }
        Carousel.handleRootCategories = function (selector) {
            var swiperParams = {
                direction: 'horizontal',
                slidesPerView: 1.5,
                centeredSlides: true,
                spaceBetween: 11,
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev',
                },
                breakpoints: {
                    550: {
                        slidesPerView: 2,
                        centeredSlides: false,
                    },
                    768: {
                        slidesPerView: 3,
                        centeredSlides: false,
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 18,
                        centeredSlides: false,
                    },
                },
            };
            new swiper.Swiper(selector, swiperParams);
        };
        Carousel.handleOtherProducts = function (selector) {
            var swiperParams = {
                direction: 'horizontal',
                slidesPerView: 1.35,
                spaceBetween: 20,
                centeredSlides: false,
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev',
                },
                breakpoints: {
                    550: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 24,
                        centeredSlides: true,
                    },
                },
            };
            new swiper.Swiper(selector, swiperParams);
        };
        return Carousel;
    }());

}(window));
typeof tsBuild === 'function' && tsBuild();})();
